import { render, staticRenderFns } from "./BusStandardTeamConfigModalbefore.vue?vue&type=template&id=dadaf90e&"
import script from "./BusStandardTeamConfigModalbefore.vue?vue&type=script&lang=js&"
export * from "./BusStandardTeamConfigModalbefore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports